<template>
    <div
        class="sbs-pagination-item trs"
        :class="paginationItemClasses"
        @click="changePage">
        <!-- @slot Слот для номера страницы -->
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'SbsPaginationItem',
    computed: {
        paginationItemClasses() {
            return [
                { 'sbs-pagination-item--active': this.isActive },
                { 'sbs-pagination-item--dots': this.isShowDots },
            ];
        },
    },
    methods: {
        changePage() {
            if (this.isShowDots) return;

            this.$emit('changePage');
        },
    },
    props: {
        isActive: {
            type: Boolean,
            default: false,
        },
        isShowDots: {
            type: Boolean,
            default: false,
        },
    },
};
</script>


<style lang="scss" scoped>
.sbs-pagination-item {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    color: $gray-deep;
    border-radius: 50px;
    cursor: pointer;
    user-select: none;

    &--dots {
        cursor: default;
    }

    &--active {
        color: $black;
        background: $white;
    }

    &:not(&--dots):hover {
        color: $black;
        background: $white;
    }
}
</style>
